import React from 'react';

export default function AskAdminToEnableIntegrations() {
    return <p> Ask your admin to enable this integration </p>;
}
